class AyaTestimonialGrid extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.aya-testimonial'));
    this.dots = this.querySelector('.aya-testimonials__dots');
    this.basePerPage = parseInt(this.dataset.perPage, 10) || 4;
    this.page = Math.max(0, (parseInt(this.dataset.startIndex, 10) || 1) - 1);
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.mobileQuery.addEventListener('change', () => this.render());
    this.grid = this.querySelector('.aya-testimonials__grid');
    this.grid?.addEventListener('scroll', () => this.syncMobileDots(), { passive: true });

    this.render();
  }

  get perPage() {
    return this.mobileQuery.matches ? 1 : this.basePerPage;
  }

  render() {
    if (this.mobileQuery.matches) {
      this.renderMobileCarousel();
      return;
    }

    const perPage = this.perPage;
    const pageCount = Math.max(1, this.cards.length);
    this.page = Math.min(this.page, pageCount - 1);

    this.cards.forEach((card) => {
      card.hidden = true;
      card.style.order = '';
    });

    const visibleCount = Math.min(perPage, this.cards.length);
    for (let offset = 0; offset < visibleCount; offset += 1) {
      const card = this.cards[(this.page + offset) % this.cards.length];
      card.hidden = false;
      card.style.order = offset;
    }

    this.renderDots(pageCount);
  }

  renderMobileCarousel() {
    this.cards.forEach((card) => {
      card.hidden = false;
      card.style.order = '';
    });
    this.renderDots(this.cards.length);
  }

  syncMobileDots() {
    if (!this.mobileQuery.matches || !this.dots || !this.grid) return;
    const dots = Array.from(this.dots.children);
    if (!dots.length) return;
    let active = 0;
    let distance = Infinity;
    this.cards.forEach((card, index) => {
      const current = Math.abs(card.getBoundingClientRect().left - this.grid.getBoundingClientRect().left);
      if (current < distance) {
        distance = current;
        active = index;
      }
    });
    this.page = active;
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === active);
      dot.setAttribute('aria-selected', index === active ? 'true' : 'false');
    });
  }

  renderDots(pageCount) {
    if (!this.dots) return;

    this.dots.innerHTML = '';
    this.dots.hidden = pageCount <= 1;

    for (let i = 0; i < pageCount; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `aya-testimonials__dot${i === this.page ? ' is-active' : ''}`;
      dot.setAttribute('aria-label', `Show testimonials page ${i + 1}`);
      // The dots container carries role="tablist" (markup, see this
      // section's .liquid file); WAI-ARIA requires a tablist's children to
      // be role="tab" — Lighthouse/axe flags this as `aria-required-children`
      // otherwise.
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', i === this.page ? 'true' : 'false');
      dot.addEventListener('click', () => {
        this.page = i;
        if (this.mobileQuery.matches) {
          this.cards[i]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          this.syncMobileDots();
        } else {
          this.render();
        }
      });
      this.dots.appendChild(dot);
    }
  }
}

customElements.define('aya-testimonial-grid', AyaTestimonialGrid);
